export const CURRENCY = new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits:0,
    maximumFractionDigits:0
  })